import React,{Component  } from "react";

class PriceEstimation extends Component{

    render(){
        return(
            <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Tell us your pack</h2>
                  <ul className="nav navbar-right panel_toolbox">
                    <li></li>
                  </ul>
                  <div className="clearfix"></div>
                </div>
                <div className="x_content">                  					
                    <form>
                          <div className="form-group clearfix">							
                              <div className="col-sm-6 col-md-2" >
                                  <label>How many verifications?</label>
                                  <input name="email" id="email" placeholder="" className="form-control" type="text"/>
                              </div>
                              <div className="col-sm-6 col-md-2" >
                                  <label>How often?</label>
                                  <select className="form-control">
                                      <option>Monthly</option>
                                      <option>Yearly</option>
                                  </select>
                              </div>
                              <div className="col-sm-6 col-md-8">
                                  <div className="price-slider">
                                      <label>Minimum 100 verifications is required</label><br/>
                                      <div className="col-md-12">
                                        <div id="slider" className="ui-slider-handle ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all" aria-disabled="false"><a className="ui-slider-handle ui-state-default ui-corner-all ui-state-hover"
                                         href="#" ><label><span className="glyphicon glyphicon-chevron-left"></span> 0 <span className="glyphicon glyphicon-chevron-right"></span></label></a></div>
                                      </div>
                                    </div>
                              </div>
                           
                          </div>                       
                    </form>
                  </div>
                  </div>
                </div>
              </div>
          
        );
    };

};

export default PriceEstimation;


// WEBPACK FOOTER //
// ./src/components/Pricing/PricingContainer/PriceEstimation.js